import { render, staticRenderFns } from "./kuwarning.vue?vue&type=template&id=754b4579&"
import script from "./kuwarning.vue?vue&type=script&lang=js&"
export * from "./kuwarning.vue?vue&type=script&lang=js&"
import style0 from "./kuwarning.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports